/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateFormDto } from '../models';
// @ts-ignore
import type { FileMetaDataDto } from '../models';
// @ts-ignore
import type { FormBasicsDto } from '../models';
// @ts-ignore
import type { FormCsvDataDto } from '../models';
// @ts-ignore
import type { FormSectionDto } from '../models';
// @ts-ignore
import type { FormTemplateDto } from '../models';
// @ts-ignore
import type { SyncFormDto } from '../models';
// @ts-ignore
import type { UpdateFormDto } from '../models';
/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateFormDto} createFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerCreateForm: async (createFormDto: CreateFormDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormDto' is not null or undefined
            assertParamExists('formsControllerCreateForm', 'createFormDto', createFormDto)
            const localVarPath = `/api/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FormsControllerGetAvailableFormTemplatesFormBaseType} formBaseType FormBaseType to filter templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetAvailableFormTemplates: async (formBaseType: FormsControllerGetAvailableFormTemplatesFormBaseType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formBaseType' is not null or undefined
            assertParamExists('formsControllerGetAvailableFormTemplates', 'formBaseType', formBaseType)
            const localVarPath = `/api/forms/available-form-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (formBaseType !== undefined) {
                localVarQueryParameter['formBaseType'] = formBaseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<FormsControllerGetAvailableFormsFormBaseTypes>} [formBaseTypes] 
         * @param {string} [procurementSupplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetAvailableForms: async (formBaseTypes?: Array<FormsControllerGetAvailableFormsFormBaseTypes>, procurementSupplierId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forms/available-forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (formBaseTypes) {
                localVarQueryParameter['formBaseTypes'] = formBaseTypes;
            }

            if (procurementSupplierId !== undefined) {
                localVarQueryParameter['procurementSupplierId'] = procurementSupplierId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetFormCsvData: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerGetFormCsvData', 'formId', formId)
            const localVarPath = `/api/forms/{formId}/csv-data`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetFormSections: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerGetFormSections', 'formId', formId)
            const localVarPath = `/api/forms/{formId}/form-sections`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [formBaseTypes] 
         * @param {number} [relatedFeature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetReportsMetaData: async (formBaseTypes?: Array<string>, relatedFeature?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forms/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (formBaseTypes) {
                localVarQueryParameter['formBaseTypes'] = formBaseTypes;
            }

            if (relatedFeature !== undefined) {
                localVarQueryParameter['relatedFeature'] = relatedFeature;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FormsControllerGetUploadsMetaDataFormBaseType} formBaseType FormBaseType to filter uploads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetUploadsMetaData: async (formBaseType: FormsControllerGetUploadsMetaDataFormBaseType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formBaseType' is not null or undefined
            assertParamExists('formsControllerGetUploadsMetaData', 'formBaseType', formBaseType)
            const localVarPath = `/api/forms/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (formBaseType !== undefined) {
                localVarQueryParameter['formBaseType'] = formBaseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {Array<FormCsvDataDto>} formCsvDataDto Form csv data array to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerImportFormCsvData: async (formId: string, formCsvDataDto: Array<FormCsvDataDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerImportFormCsvData', 'formId', formId)
            // verify required parameter 'formCsvDataDto' is not null or undefined
            assertParamExists('formsControllerImportFormCsvData', 'formCsvDataDto', formCsvDataDto)
            const localVarPath = `/api/forms/{formId}/csv-data`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formCsvDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerLockForm: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerLockForm', 'formId', formId)
            const localVarPath = `/api/forms/{formId}/lock`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerRemoveForm: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerRemoveForm', 'formId', formId)
            const localVarPath = `/api/forms/{formId}/remove`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {SyncFormDto} syncFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerSyncForm: async (formId: string, syncFormDto: SyncFormDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerSyncForm', 'formId', formId)
            // verify required parameter 'syncFormDto' is not null or undefined
            assertParamExists('formsControllerSyncForm', 'syncFormDto', syncFormDto)
            const localVarPath = `/api/forms/{formId}/sync-form`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncFormDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerUnlockForm: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerUnlockForm', 'formId', formId)
            const localVarPath = `/api/forms/{formId}/unlock`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {UpdateFormDto} updateFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerUpdateForm: async (formId: string, updateFormDto: UpdateFormDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsControllerUpdateForm', 'formId', formId)
            // verify required parameter 'updateFormDto' is not null or undefined
            assertParamExists('formsControllerUpdateForm', 'updateFormDto', updateFormDto)
            const localVarPath = `/api/forms/{formId}/update`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateFormDto} createFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerCreateForm(createFormDto: CreateFormDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerCreateForm(createFormDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FormsControllerGetAvailableFormTemplatesFormBaseType} formBaseType FormBaseType to filter templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerGetAvailableFormTemplates(formBaseType: FormsControllerGetAvailableFormTemplatesFormBaseType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerGetAvailableFormTemplates(formBaseType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerGetAvailableFormTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<FormsControllerGetAvailableFormsFormBaseTypes>} [formBaseTypes] 
         * @param {string} [procurementSupplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerGetAvailableForms(formBaseTypes?: Array<FormsControllerGetAvailableFormsFormBaseTypes>, procurementSupplierId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormBasicsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerGetAvailableForms(formBaseTypes, procurementSupplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerGetAvailableForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerGetFormCsvData(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormCsvDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerGetFormCsvData(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerGetFormCsvData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerGetFormSections(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormSectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerGetFormSections(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerGetFormSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [formBaseTypes] 
         * @param {number} [relatedFeature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerGetReportsMetaData(formBaseTypes?: Array<string>, relatedFeature?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileMetaDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerGetReportsMetaData(formBaseTypes, relatedFeature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerGetReportsMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FormsControllerGetUploadsMetaDataFormBaseType} formBaseType FormBaseType to filter uploads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerGetUploadsMetaData(formBaseType: FormsControllerGetUploadsMetaDataFormBaseType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileMetaDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerGetUploadsMetaData(formBaseType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerGetUploadsMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {Array<FormCsvDataDto>} formCsvDataDto Form csv data array to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerImportFormCsvData(formId: string, formCsvDataDto: Array<FormCsvDataDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerImportFormCsvData(formId, formCsvDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerImportFormCsvData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerLockForm(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerLockForm(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerLockForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerRemoveForm(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerRemoveForm(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerRemoveForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {SyncFormDto} syncFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerSyncForm(formId: string, syncFormDto: SyncFormDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerSyncForm(formId, syncFormDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerSyncForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerUnlockForm(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerUnlockForm(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerUnlockForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {UpdateFormDto} updateFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsControllerUpdateForm(formId: string, updateFormDto: UpdateFormDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsControllerUpdateForm(formId, updateFormDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsApi.formsControllerUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateFormDto} createFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerCreateForm(createFormDto: CreateFormDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.formsControllerCreateForm(createFormDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FormsControllerGetAvailableFormTemplatesFormBaseType} formBaseType FormBaseType to filter templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetAvailableFormTemplates(formBaseType: FormsControllerGetAvailableFormTemplatesFormBaseType, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormTemplateDto>> {
            return localVarFp.formsControllerGetAvailableFormTemplates(formBaseType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<FormsControllerGetAvailableFormsFormBaseTypes>} [formBaseTypes] 
         * @param {string} [procurementSupplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetAvailableForms(formBaseTypes?: Array<FormsControllerGetAvailableFormsFormBaseTypes>, procurementSupplierId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormBasicsDto>> {
            return localVarFp.formsControllerGetAvailableForms(formBaseTypes, procurementSupplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetFormCsvData(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormCsvDataDto>> {
            return localVarFp.formsControllerGetFormCsvData(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetFormSections(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormSectionDto>> {
            return localVarFp.formsControllerGetFormSections(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [formBaseTypes] 
         * @param {number} [relatedFeature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetReportsMetaData(formBaseTypes?: Array<string>, relatedFeature?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<FileMetaDataDto>> {
            return localVarFp.formsControllerGetReportsMetaData(formBaseTypes, relatedFeature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FormsControllerGetUploadsMetaDataFormBaseType} formBaseType FormBaseType to filter uploads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerGetUploadsMetaData(formBaseType: FormsControllerGetUploadsMetaDataFormBaseType, options?: RawAxiosRequestConfig): AxiosPromise<Array<FileMetaDataDto>> {
            return localVarFp.formsControllerGetUploadsMetaData(formBaseType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {Array<FormCsvDataDto>} formCsvDataDto Form csv data array to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerImportFormCsvData(formId: string, formCsvDataDto: Array<FormCsvDataDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsControllerImportFormCsvData(formId, formCsvDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerLockForm(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsControllerLockForm(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerRemoveForm(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsControllerRemoveForm(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {SyncFormDto} syncFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerSyncForm(formId: string, syncFormDto: SyncFormDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsControllerSyncForm(formId, syncFormDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerUnlockForm(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsControllerUnlockForm(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {UpdateFormDto} updateFormDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsControllerUpdateForm(formId: string, updateFormDto: UpdateFormDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsControllerUpdateForm(formId, updateFormDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
    /**
     * 
     * @param {CreateFormDto} createFormDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerCreateForm(createFormDto: CreateFormDto, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerCreateForm(createFormDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FormsControllerGetAvailableFormTemplatesFormBaseType} formBaseType FormBaseType to filter templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerGetAvailableFormTemplates(formBaseType: FormsControllerGetAvailableFormTemplatesFormBaseType, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerGetAvailableFormTemplates(formBaseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<FormsControllerGetAvailableFormsFormBaseTypes>} [formBaseTypes] 
     * @param {string} [procurementSupplierId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerGetAvailableForms(formBaseTypes?: Array<FormsControllerGetAvailableFormsFormBaseTypes>, procurementSupplierId?: string, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerGetAvailableForms(formBaseTypes, procurementSupplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerGetFormCsvData(formId: string, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerGetFormCsvData(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerGetFormSections(formId: string, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerGetFormSections(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [formBaseTypes] 
     * @param {number} [relatedFeature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerGetReportsMetaData(formBaseTypes?: Array<string>, relatedFeature?: number, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerGetReportsMetaData(formBaseTypes, relatedFeature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FormsControllerGetUploadsMetaDataFormBaseType} formBaseType FormBaseType to filter uploads
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerGetUploadsMetaData(formBaseType: FormsControllerGetUploadsMetaDataFormBaseType, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerGetUploadsMetaData(formBaseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {Array<FormCsvDataDto>} formCsvDataDto Form csv data array to import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerImportFormCsvData(formId: string, formCsvDataDto: Array<FormCsvDataDto>, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerImportFormCsvData(formId, formCsvDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerLockForm(formId: string, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerLockForm(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerRemoveForm(formId: string, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerRemoveForm(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {SyncFormDto} syncFormDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerSyncForm(formId: string, syncFormDto: SyncFormDto, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerSyncForm(formId, syncFormDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerUnlockForm(formId: string, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerUnlockForm(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {UpdateFormDto} updateFormDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsControllerUpdateForm(formId: string, updateFormDto: UpdateFormDto, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).formsControllerUpdateForm(formId, updateFormDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const FormsControllerGetAvailableFormTemplatesFormBaseType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13
} as const;
export type FormsControllerGetAvailableFormTemplatesFormBaseType = typeof FormsControllerGetAvailableFormTemplatesFormBaseType[keyof typeof FormsControllerGetAvailableFormTemplatesFormBaseType];
/**
 * @export
 */
export const FormsControllerGetAvailableFormsFormBaseTypes = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13
} as const;
export type FormsControllerGetAvailableFormsFormBaseTypes = typeof FormsControllerGetAvailableFormsFormBaseTypes[keyof typeof FormsControllerGetAvailableFormsFormBaseTypes];
/**
 * @export
 */
export const FormsControllerGetUploadsMetaDataFormBaseType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13
} as const;
export type FormsControllerGetUploadsMetaDataFormBaseType = typeof FormsControllerGetUploadsMetaDataFormBaseType[keyof typeof FormsControllerGetUploadsMetaDataFormBaseType];
